import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../../../constants/Languages.js';

const RecordHeader = ({clang, creationTime, id, name}) => {
    return (
        <div className="record__header">
            <div className="record__mobile-name">
                {name}
            </div>
            {(creationTime || id) &&
                <div className="record__meta-data">
                    {creationTime &&
                        <span className="record__meta-data__item">{lang[clang].item.release_date}: <strong>{creationTime}</strong></span>}
                    {id &&
                        <span className="record__meta-data__item">{lang[clang].item.cards.card_id}: <strong>{id}</strong></span>}
                </div>}
        </div>
    );
};

RecordHeader.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default connect(mapStateToProps)(RecordHeader);



// WEBPACK FOOTER //
// ./src/components/items/records/common/RecordHeader.js